<h5 [id]="describedbyValue" *ngIf="listTitle" [innerHTML]="listTitle"></h5>

<div class="container-termListComponent">
  <div class="viewport">
    <ul>
      <li *ngFor="let term of terms; trackBy: trackByFn">
        <a (click)="trackUsage(term.name, term)" [routerLink]="term.urlArray" [queryParams]="term.queryObject" [innerHTML]="term.name" class="btn" *ngIf="!listTitle"></a>
        <a (click)="trackUsage(term.name, term)" [routerLink]="term.urlArray" [queryParams]="term.queryObject" [innerHTML]="term.name" class="btn" [attr.aria-describedby]="describedbyValue" *ngIf="listTitle"></a>
      </li>
    </ul>
  </div>
</div>
